import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  inject,
  input,
} from '@angular/core';
import type { ValidatorFn } from '@angular/forms';

import { MessageComponent, SpinnerComponent } from '@core/user-interface-legacy';

import { Destroyable, takeUntilDestroyed } from '../../../common';
import type { DynamicFormLoaderConfig } from '../../types';
import { DynamicFormInput } from '../dynamic-form/dynamic-form-input/dynamic-form-input';
import { DynamicFormResourcesService } from '../dynamic-form/dynamic-form-resources.service';

const alwaysFalseValidator = (_: any): {} => ({ formLoader: true });

export class FormLoaderInput extends DynamicFormInput<DynamicFormLoaderConfig> {
  protected validators(): ValidatorFn[] {
    return super.validators().concat([alwaysFalseValidator]);
  }
}

@Component({
  selector: 'rti-form-loader-input',
  templateUrl: './form-loader-input.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MessageComponent, SpinnerComponent],
})
@Destroyable()
export class FormLoaderInputComponent {
  private readonly cdRef = inject(ChangeDetectorRef);
  private readonly resourcesSvc = inject(DynamicFormResourcesService);

  public readonly input = input<FormLoaderInput>(undefined!);

  public loading: boolean = true;
  public errors: string[] = [];

  public ngOnInit(): void {
    this.resourcesSvc.loading$.pipe(takeUntilDestroyed(this)).subscribe(loading => {
      this.loading = loading;
      this.cdRef.detectChanges();
    });

    this.resourcesSvc.formError$.pipe(takeUntilDestroyed(this)).subscribe(error => {
      this.errors = error;
      this.cdRef.detectChanges();
    });
  }

  public trackByErrorMessage(_index: number, error: string): string {
    return error;
  }
}
